export default {
  setLoading: (state, loading) => (state.loading = loading),
};
